import { Loader2, Mic } from 'lucide-react'

export interface DictationOverlayProps {
  onStop: () => void
  /**
   * 'transcribing' covers the gap between stopping the recording and the text
   * coming back from the transcription model.
   */
  state?: 'listening' | 'transcribing'
}

/** Full-body listening state (Screen 4). Tap anywhere to stop. */
export function DictationOverlay({ onStop, state = 'listening' }: DictationOverlayProps) {
  const transcribing = state === 'transcribing'
  return (
    <button
      type="button"
      onClick={transcribing ? undefined : onStop}
      disabled={transcribing}
      className="flex flex-1 flex-col items-center justify-center gap-4 px-6 enabled:cursor-pointer"
    >
      <span className="relative flex h-28 w-28 items-center justify-center">
        {!transcribing && (
          <span className="absolute inset-0 animate-ping rounded-full bg-red-100" />
        )}
        <span
          className={
            transcribing
              ? 'relative flex h-20 w-20 items-center justify-center rounded-full bg-brand-50 text-brand-600'
              : 'relative flex h-20 w-20 items-center justify-center rounded-full bg-red-50 text-red-500'
          }
        >
          {transcribing ? (
            <Loader2 className="h-8 w-8 animate-spin" />
          ) : (
            <Mic className="h-8 w-8" />
          )}
        </span>
      </span>
      {!transcribing && <Waveform />}
      <div className="text-center">
        <div className="text-base font-semibold text-neutral-800">
          {transcribing ? 'Übertrage…' : 'Höre zu…'}
        </div>
        <div className="mt-0.5 text-sm text-neutral-400">
          {transcribing
            ? 'Das Gesprochene wird in Text umgewandelt'
            : 'Sprich jetzt — Tippen zum Stoppen'}
        </div>
      </div>
    </button>
  )
}

function Waveform() {
  const bars = [10, 18, 28, 16, 24, 12, 20, 30, 14, 22, 10]
  return (
    <div className="flex items-end gap-1" aria-hidden>
      {bars.map((h, i) => (
        <span
          key={i}
          className="w-1 animate-pulse rounded-full bg-red-400"
          style={{ height: `${h}px`, animationDelay: `${i * 90}ms` }}
        />
      ))}
    </div>
  )
}
